import creator from '@utils/creator.js';

import Filters from '@components/Filters';

function ClrzAppInit() {
	ClrzApp.Filters = creator('.js-filters-mobile', Filters);
}

ClrzAppInit();
